import $ from 'jquery';

export default class Header {
	constructor() {
		this.body = $('.page');
		this.menu = $('.header__menu');
		this.menuWrapper = $('.header__menu-wrapper');
		this.menuTop = 87;
		this.personalBtn = $('.header__personal-btn');
		this.personalList = $('.header__personal-list');
		this.mobileBurger = $('.header__burger');
		this.mobileTop = $('.header__mobile-top');
		this.mobileNav = $('.header__nav');
		this.panelItem = $('button.panel__item');
		this.panelBackBtn = $('.panel__back-btn');
		this.gdprBanner = $('.gdpr-banner');
	}

	init() {
		$(window).on('load scroll resize', () => {
			if ($(window).width() >= 1024) {
				if ($(window).scrollTop() >= this.menuTop) {
					this.menuWrapper.css({
						'min-height': this.menu.height()
					});
					this.menu.addClass('header__menu_fixed');

					if (!this.gdprBanner.hasClass('gdpr-banner_hide')) {
						this.menu.css({
							top: this.gdprBanner.height()
						});
					}else {
						this.menu.animate({
							top: 0
						}, 300);
					}
				}else {
					this.menu.removeClass('header__menu_fixed');
				}
			}
		});

		$(window).on('load resize', () => {
			if ($(window).width() < 1024 && !this.gdprBanner.hasClass('gdpr-banner_hide')) {
				this.mobileTop.css({
					top: this.gdprBanner.height()
				});
				this.mobileNav.css({
					top: this.gdprBanner.height() + 68
				});
			}else {
				this.mobileTop.css({
					top: 0
				});
				this.mobileNav.css({
					top: 68
				});
			}
		});

		this.personalBtn.on('click', event => {
			event.preventDefault();

			this.personalBtn.toggleClass('header__personal-btn_open');
			this.personalList.toggleClass('header__personal-list_open');
		});

		$(document.body).on('click', event => {
			if (!$(event.target).closest('.header__personal').length && this.personalBtn.hasClass('header__personal-btn_open')) {
				this.personalBtn.removeClass('header__personal-btn_open');
				this.personalList.removeClass('header__personal-list_open');
			}
		});

		this.mobileBurger.on('click', event => {
			event.preventDefault();

			this.mobileBurger.toggleClass('header__burger_open');
			this.mobileNav.toggleClass('header__nav_open');
			this.body.toggleClass('page_menu-open');
		});

		this.panelItem.on('click', function (event) {
			event.preventDefault();

			$(this).siblings('.panel__submenu').addClass('panel__submenu_open');
		});

		this.panelBackBtn.on('click', function (event) {
			event.preventDefault();

			$(this).parent().removeClass('panel__submenu_open');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/header/index.js